import { createContext, useCallback, useState } from "react";

const UIContext = createContext({});

export const UIContextProvider = ({ children }) => {
  // Nav Sidebar State
  const [navOpen, setNavOpen] = useState(true);
  // Snack Bar State
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertPersistent, setAlertPersistent] = useState(false); // Add this
  // Progress Loading State
  const [openLoader, setOpenLoader] = useState(false);

  // Loading Handlers
  const showLoading = useCallback(() => {
    setOpenLoader(true);
  }, []);

  const hideLoading = useCallback(() => {
    setOpenLoader(false);
  }, []);

  // SnackBar Handlers
  const openSnackBar = useCallback((message, type = 'success', persistent = false) => {
    setAlertType(type);
    setAlertMessage(message);
    setAlertPersistent(persistent);
    setAlertOpen(true);
  }, []);

  const closeSnackBar = useCallback(() => {
    setAlertMessage('');
    setAlertOpen(false);
    setAlertPersistent(false);
  }, []);

  return (
    <UIContext.Provider
      value={{
        openSnackBar,
        closeSnackBar,
        alertOpen,
        alertType,
        alertMessage,
        alertPersistent,
        showLoading,
        hideLoading,
        openLoader,
        navOpen,
        setNavOpen,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export default UIContext;